import "./assets/scss/theme.scss"
import React, { useEffect, useCallback, useState } from "react"
import { useDispatch, useSelector } from 'react-redux'
import { BrowserRouter as Router } from "react-router-dom"
import VerticalLayout from "./components/VerticalLayout/"
import HorizontalLayout from "./components/HorizontalLayout/"
import NonAuthLayout from "./components/NonAuthLayout"
import PageSpinner from './components/Spinners/PageSpinner'
import UnauthMiddleware from "./routes/middleware/UnauthMiddleware"
import Authmiddleware from "./routes/middleware/Authmiddleware"
import { AGENT_USER_TYPE_ID, ERROR_KEY } from "./Constants/MainKeys"
import ChooseActiveAgentModal from "./pages/Agent-Pages/Components/ChooseActiveAgentModal"
import { addRightSectionSpinner, removeRightSectionSpinner, updateUserData } from "./store/actions"
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import SiteTourComponent from "./SiteTourComponent"
import Listeners from "./Listeners"
import ApiService from "./Services/ApiService"
import { setAccountTypes, setCountries, setRoutingTypes } from "./store/main/actions"
import AlertService from "./Services/alertService"
import uuid from "react-uuid"
import ClearSessionFilter from "./ClearSessionFilter"
import { NetworkProvider } from "./NetworkContext"
import InternetStatusModal from "./components/InternetStatusModal/InternetStatusModal"
import LangProvider from "./lang/LangProvider"
import TranslationProvider from "./lang/TranslationProvider"

export const checkServer = async (url) => {
  // Hrona asel vor anjatem 13.01.2026
  // return false;
  if (!url) { return false; }
  try {
    const res = await fetch(`${url}/ok`, {
      method: "GET",
      cache: "no-store",
    });
    if (!res) {
      return { status: "server-error" };
    }
    return { status: "ok" };
  } catch (error) {
    return { status: "server-error" };
  }
};

const App = () => {

  const dispatch = useDispatch()
  const { user } = useSelector(state => state.Login);
  const { pageSpinners } = useSelector(state => state.Spinners);
  const layout = useSelector(state => state.Layout);

  const [isShowChooseActiveAgentModal, setIsShowChooseActiveAgentModal] = useState(false);

  useEffect(() => {
    if (user && user.agentDashbaords && user.agentDashbaords.length && user.userTypeId === AGENT_USER_TYPE_ID && !user.activeAgentId) {
      if (user.agentDashbaords.length === 1) {
        const userCopy = { ...user }
        userCopy.activeAgentId = user.agentDashbaords[0].id;
        dispatch(updateUserData(userCopy));
      } else {
        setIsShowChooseActiveAgentModal(true)
      }
    } else {
      setIsShowChooseActiveAgentModal(false)
    }
  }, [user])

  const getLayout = () => {
    let layoutCls = VerticalLayout
    switch (layout.layoutType) {
      case "horizontal":
        layoutCls = HorizontalLayout
        break
      default:
        layoutCls = VerticalLayout
        break
    }
    return layoutCls
  }

  const Layout = getLayout();

  useEffect(() => {
    if (user) {
      getCountries();
      getAccountTypes();
      getRoutingTypesLibrary();
    }
  }, [user])

  const getCountries = () => {
    const spinnerId = uuid();
    setRightSectionSpinner(spinnerId);
    ApiService.getCountries().then(response => {
      if (response && response.data) {
        dispatch(setCountries(response.data));
      } else {
        dispatch(setCountries([]));
      }
    }).catch(error => getFail(error)).finally(() => {
      extractRightSectionSpinner(spinnerId)
    })
  }

  const getAccountTypes = () => {
    const spinnerId = uuid();
    setRightSectionSpinner(spinnerId);
    ApiService.getAccountTypes().then(response => {
      if (response) {
        dispatch(setAccountTypes(response))
      }
    }).catch(error => getFail(error)).finally(() => {
      extractRightSectionSpinner(spinnerId)
    })
  }

  const getRoutingTypesLibrary = () => {
    const spinnerId = uuid();
    setRightSectionSpinner(spinnerId);
    ApiService.getRoutingTypesLibrary().then(response => {
      if (response) {
        dispatch(setRoutingTypes(response))
      }
    }).catch(error => getFail(error)).finally(() => {
      extractRightSectionSpinner(spinnerId)
    })
  }

  const setRightSectionSpinner = useCallback(spinner => {
    dispatch(addRightSectionSpinner(spinner));
  }, []);

  const extractRightSectionSpinner = useCallback(spinner => {
    dispatch(removeRightSectionSpinner(spinner));
  }, []);

  const getFail = (error) => {
    error && AlertService.alert((AlertService.checkMessageType(error.respcode) || ERROR_KEY), error);
  }

  return (
    <LangProvider>
      <TranslationProvider>
        <Router>
          {
            user ?
              <Layout>
                <NetworkProvider>
                  <InternetStatusModal />
                  <Authmiddleware />
                </NetworkProvider>
              </Layout>
              :
              <NonAuthLayout>
                <UnauthMiddleware />
              </NonAuthLayout>
          }
        </Router>
        <PageSpinner spinner={pageSpinners} />
        {/* <ErrorHandling /> */}

        {
          isShowChooseActiveAgentModal ?
            <ChooseActiveAgentModal agents={user.agentDashbaords} />
            : null
        }
        <ToastContainer
          theme="light"
        // limit={2} //Limit the number of toast displayed at the same time
        // autoClose={5000} 
        />
        <SiteTourComponent />
        <Listeners />
        <ClearSessionFilter />
      </TranslationProvider>
    </LangProvider>
  )
}

export default App
